module.exports = __webpack_public_path__ + "static/media/Next.js.1931be01.svg";